import type { Layout, LayoutChangedMeta } from 'react-resizable-panels';

import { DETAIL_LAYOUT_PANE_SIZES } from './detail-layout-pane-sizes.js';
import { useDragShutPane } from './use-drag-shut-pane.js';
import { usePersistedPanelLayout } from './use-persisted-panel-layout.js';

type UseDetailLayoutPanelsOptions = Readonly<{
  autoSaveId: string | undefined;
  leftPaneVisible: boolean;
  rightPaneVisible: boolean;
  onLeftPaneDragShut: () => void;
  onRightPaneDragShut: () => void;
}>;

export function useDetailLayoutPanels({
  autoSaveId,
  leftPaneVisible,
  rightPaneVisible,
  onLeftPaneDragShut,
  onRightPaneDragShut,
}: UseDetailLayoutPanelsOptions) {
  const leftPanel = useDragShutPane({
    panelId: 'left',
    onDragShut: onLeftPaneDragShut,
    reopenSize: DETAIL_LAYOUT_PANE_SIZES.left.defaultSize,
  });
  const rightPanel = useDragShutPane({
    panelId: 'right',
    onDragShut: onRightPaneDragShut,
    reopenSize: DETAIL_LAYOUT_PANE_SIZES.right.defaultSize,
  });
  const { defaultLayout, onLayoutChanged: saveLayout } = usePersistedPanelLayout({
    autoSaveId,
    leftPaneVisible,
    rightPaneVisible,
  });

  const onLayoutChanged = (layout: Layout, meta: LayoutChangedMeta) => {
    leftPanel.onLayoutChanged(layout, meta);
    rightPanel.onLayoutChanged(layout, meta);
    saveLayout(layout, meta);
  };

  return {
    defaultLayout,
    onLayoutChanged,
    leftPanelRef: leftPanel.panelRef,
    rightPanelRef: rightPanel.panelRef,
  };
}
